import { useMutation } from "@tanstack/react-query";
import { Button, Form, Modal, message } from "antd";
import dayjs from "dayjs";
import { useState } from "react";
import { AiOutlineEdit } from "react-icons/ai";
import { UpdateOpeningHoursAdmin } from "../../../network/admin";
import queryClient from "../../../services/react-query/queryClient";
import WorkingHours from "../../settings/TapsSalon/components/items/WorkingHours";
import WorkingsHoursEdit from "../../settings/TapsSalon/components/items/WorkingsHoursEdit";

type Props = {
  opening_hours: any;
  style?: string;
  salonId: number;
  salonName: string;
};
const daysOfWeek = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
const SalonWorkingsHour = ({
  opening_hours,
  style,
  salonId,
  salonName,
}: Props) => {
  const [modal, setModal] = useState(false);
  const [form] = Form.useForm();

  const closeModal = () => {
    setModal(false);
  };
  const openModal = () => {
    setModal(true);
    console.log(modal);
  };
  const filterOpeningHours = (e?: any) => {
    const openingHoursMap = new Map(
      opening_hours?.map((day: any) => [day?.day, day])
    );
    const result = daysOfWeek?.map((day) => {
      const existingDay = openingHoursMap?.get(day);
      if (existingDay) {
        return { ...existingDay, off: false };
      } else {
        return {
          day,
          opening_time: "00:09:00",
          closing_time: "00:17:00",
          off: true,
        }; // Assuming day is the name of the day of the week
      }
    });

    return result;
  };
  const {
    mutate: UpdateOpeningHours,
    isLoading: isSubmitting,
    error: addSalonError,
  } = useMutation(UpdateOpeningHoursAdmin, {
    onSuccess: (res: any) => {
      if (res?.code === "ERR_BAD_REQUEST") {
        message.error(res?.response?.data?.message);
      } else {
        message.success("Opening Hours Updated Successfully");
        queryClient.invalidateQueries(["location"]);
        closeModal();
      }
    },
  });
  const onFinish = (value: any) => {
    const opening_hoursData: any = Object?.entries(value?.opening_hours)?.map(
      ([day, { opening_time, closing_time }]: [string, any]) => {
        const formattedOpeningTime = dayjs(opening_time).format("HH:mm");
        const formattedClosingTime = dayjs(closing_time).format("HH:mm");
        return {
          day: day,
          opening_time: formattedOpeningTime,
          closing_time: formattedClosingTime,
        };
      }
    );

    console.log(
      salonId,
      opening_hoursData,
      "salonId, opening_hoursDatasalonId, opening_hoursDatasalonId, opening_hoursData"
    );

    UpdateOpeningHours({ id: salonId, opening_hours: opening_hoursData });
  };
  const openingAndClosingTimes: any = {};
  opening_hours?.forEach((data: any) => {
    const hour1 = parseInt(data?.opening_time?.split(":")[0], 10);
    const hour2 = parseInt(data?.closing_time?.split(":")[0], 10);
    const min1 = parseInt(data?.opening_time?.split(":")[1], 10);
    const min2 = parseInt(data?.closing_time?.split(":")[1], 10);
    console.log(data, "min1");
    console.log(min1, min2, "min1min1min1");

    openingAndClosingTimes[data?.day] = {
      opening_time: dayjs().hour(hour1).minute(min1),
      closing_time: dayjs().hour(hour2).minute(min2),
    };
  });
  return (
    <>
      <Modal
        width="60%"
        destroyOnClose={true}
        maskClosable={false}
        centered
        className="overflow-y-auto max-md:!w-[95%] max-xl:!w-[75%]"
        open={modal}
        onCancel={closeModal}
        footer={false}
      >
        <div className="text-2xl font-semibold leading-7 text-center text-color-primary">
          Edit salon working hours
        </div>
        <div className="my-4 text-base font-normal leading-7 text-center text-color-gray">
          {salonName}
        </div>
        <Form
          name="EditSalonBranch"
          form={form}
          className="grid-cols-2 my-8 lg:grid lg:grid-cols-2 max-md:grid-cols-1"
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            opening_hours: openingAndClosingTimes,
          }}
        >
          {filterOpeningHours()?.map(
            ({ day, opening_time, closing_time, off }: any, index: number) => (
              <WorkingsHoursEdit
                form={form}
                day={day}
                opening_time={opening_time}
                closing_time={closing_time}
                off={off}
                index={index}
              />
            )
          )}
          <div className="flex items-center w-full col-span-2 gap-4">
            <Button
              type="primary"
              htmlType="submit"
              className="w-full capitalize"
              // loading={isSubmitting}
            >
              Save
            </Button>
            <Button
              // onClick={() => setIsEdit((e: any) => !e)}
              type="primary"
              className="w-full capitalize btn-primary-not"
            >
              cancel
            </Button>
          </div>
        </Form>
      </Modal>
      <div
        className={`bg-white h-full px-4 py-[18px] rounded-xl w-full ${style}`}
      >
        <div className="flex items-center justify-between mb-4">
          <h4 className="text-xl font-semibold text-color-primary">
            Salon working hours
          </h4>
          <AiOutlineEdit
            onClick={openModal}
            className="flex items-center justify-center cursor-pointer"
          />
        </div>

        <div className="grid items-center grid-cols-3 gap-4">
          {filterOpeningHours()?.map(
            ({ day, opening_time, closing_time }: any) => (
              <WorkingHours
                day={day}
                start={opening_time}
                end={closing_time}
                bgdis={"!bg-[#CFCFE2]"}
                style="!my-0 !bg-[#EEF0FF] !h-[95px]"
              />
            )
          )}
        </div>
      </div>
    </>
  );
};

export default SalonWorkingsHour;
